import React, { useState } from "react";
import axios from "../../axiosConfig";
import "../../styles/ExerciseModal.css";
import { AiOutlineClose } from "react-icons/ai"; // Close icon

const EditExerciseModal = ({ exercise, onClose, onSave }) => {
    const [editForm, setEditForm] = useState({ ...exercise });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    // Mapping Polish difficulty levels to English ENUMs
    const difficultyMapping = {
        "Podstawowy": "BASIC",
        "Średniozaawansowany": "INTERMEDIATE",
        "Zaawansowany": "ADVANCED"
    };

    const handleChange = (e) => {
        setEditForm({ ...editForm, [e.target.name]: e.target.value });
    };

    const handleSave = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError("");

        try {
            const token = localStorage.getItem("jwt");

            // Convert difficulty level from Polish to English ENUM before sending to backend
            const updatedExercise = {
                ...editForm,
                difficultyLevel: difficultyMapping[editForm.difficultyLevel] || editForm.difficultyLevel,
            };

            await axios.put("/api/v1/exercise/update", updatedExercise, {
                headers: { Authorization: `Bearer ${token}` },
            });

            onSave(updatedExercise);
            onClose();
        } catch (err) {
            setError("Nie udało się zaktualizować ćwiczenia.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <div className="modal-header">
                    <h2>Edytuj ćwiczenie</h2>
                    <AiOutlineClose className="close-icon" onClick={onClose} />
                </div>
                <form onSubmit={handleSave}>
                    <div className="form-group">
                        <input type="text" name="name" value={editForm.name} onChange={handleChange} required placeholder="nazwa..." />
                    </div>
                    <div className="form-group">
                        <input type="text" name="requiredEquipment" value={editForm.requiredEquipment} onChange={handleChange} placeholder="wyposażenie" />
                    </div>
                    <div className="form-group">
                        <textarea name="description" value={editForm.description} onChange={handleChange} required placeholder="opis..." className="large-textarea" />
                    </div>
                    <div className="form-group">
                        <select name="difficultyLevel" value={editForm.difficultyLevel} onChange={handleChange}>
                            <option value="Podstawowy">Podstawowy</option>
                            <option value="Średniozaawansowany">Średniozaawansowany</option>
                            <option value="Zaawansowany">Zaawansowany</option>
                        </select>
                    </div>
                    {error && <p className="error">{error}</p>}
                    <div className="modal-buttons">
                        <button type="button" className="cancel-btn" onClick={onClose}>Anuluj</button>
                        <button type="submit" className="save-btn" disabled={loading}>
                            {loading ? "Zapisywanie..." : "Zapisz zmiany"}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default EditExerciseModal;